
import { defineComponent, ref } from 'vue';
import Receipt from '@/components/Accounting/Receipt.vue';

export default defineComponent({
    props: {
        clientId: {
            type: Number,
            required: true
        }
    },
    components: {
        Receipt
    },
    async setup() {
        return {};
    }
});
